import axios, { AxiosResponse } from "axios";

const config = {
    withCredentials: true,
};

export class APIRequest {
    async get<T>(url: string): Promise<AxiosResponse<T>> {
        return await axios.get(url, config);
    }

    async post<T>(url: string, data: any): Promise<AxiosResponse<T>> {
        return await axios.post(url, data, config);
    }

    async put<T>(url: string, data: any): Promise<AxiosResponse<T>> {
        return await axios.put(url, data, config);
    }

    async delete<T>(url: string): Promise<AxiosResponse<T>> {
        return await axios.delete(url, config);
    }

    async _upload<T>(url: string, data: any): Promise<AxiosResponse<T>> {
        return await axios.put(url, data, config);
    }
}
